import React, { useState } from "react";

import {
  Radio,
  Checkbox,
  Form,
  Input,
  Select,
  Button,
  Col,
  Row,
} from "antd";

import { eligibleCharge } from "../../../../../utils/NewPropertyHelper";

function AdditionalFees({ renwalFees, setRenewalFees }) {
  const [leaseFeeType, setLeaseFeeType] = useState("Percent");
  const [renewalFeeType, setRenewalFeeType] = useState("Percent");

  const addRenewal = () => {
    const newRenewalFees = { id: renwalFees.length + 1, glAccount: "", percentage: "", suppress: false };
    setRenewalFees([...renwalFees, newRenewalFees]);
  };

  const removeRenewal = (id) => {
    const updatedRenwalFees = renwalFees.filter((term) => term.id !== id);
    setRenewalFees(updatedRenwalFees);
  };

  const handleChange = (value, name, id) => {
    const newRenewalFees = renwalFees.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setRenewalFees(newRenewalFees);
  };


  return (
    <>
      <h4 style={{ fontSize: 13, marginBottom: 20 }}>Lease Fee</h4>

      <Form.Item
        label="Lease Fee Type"
        name="leaseFeeType"
      >
        <Radio.Group
          name="radiogroup"
          value={leaseFeeType}
          onChange={(e) => {
            setLeaseFeeType(e.target.value);
          }}
        >
          <Radio value="Flat">Flat</Radio>
          <Radio value="Percent">Percent</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        label={
          leaseFeeType === "Flat" ? "Lease Flat Fee" : "Lease Fee Percent"
        }
        name="leaseFee"
      >
        {leaseFeeType === "Flat" ? (
          <Input prefix="$" />
        ) : (
          <Input suffix="%"/>
        )}
      </Form.Item>

      <h4 style={{ fontSize: 13, marginBottom: 20 }}>Renewal Fee</h4>

      <Form.Item
        label="Renewal Fee Type"
        name="renewalFeeType"
      >
        <Radio.Group
          name="radiogroup"
          initalvalues={1}
          value={renewalFeeType}
          onChange={(e) => {
            setRenewalFeeType(e.target.value);
          }}
        >
          <Radio value="Flat">Flat</Radio>
          <Radio value="Percent">Percent</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        label={
          renewalFeeType === "Flat" ? "Renewal Flat Fee" : "Renewal Fee Percent"
        }
        name="renewalFee"
      >
        {renewalFeeType === "Flat" ? (
          <Input prefix="$" />
        ) : (
          <Input suffix="%" />
        )}
      </Form.Item>

      <h4 style={{ fontSize: 13, marginBottom: 20 }}>Additional Fees</h4>

      <Row style={{ marginBottom: 8 }}>
        <Col className="tableHead" span={13}>
          <p>GL Account</p>
        </Col>
        <Col className="tableHead" span={6}>
          <p>Percentage</p>
        </Col>
        <Col className="tableHead" span={4}>
          <p>Suppress</p>
        </Col>
        <Col span={1}></Col>
      </Row>

      <ul>
        {renwalFees.map((item, index) => (
          <li key={item.id}>
            <Row gutter={[8, 0]}>
              <Col span={13}>
                <Form.Item name={`additionalFees${index}`}>
                  <Select
                    showSearch
                    options={eligibleCharge}
                    initalvalues={eligibleCharge[0]}
                    style={{ width: "100%" }}
                    value={item.glAccount}
                    onChange={(value)=>handleChange(value, 'glAccount', item.id)}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item name={`additionalFeePercentage${index}`}>
                  <Input suffix="%" defaultValue="100" value={item.percentage}
                    onChange={(e)=>handleChange(e.target.value, 'percentage', item.id)}/>
                </Form.Item>
              </Col>
              <Col span={4} style={{ textAlign: "center" }}>
                <Form.Item name={`additionalFeeSuppress${index}`} valuePropName="checked">
                  <Checkbox checked={item.suppress} onChange={(e)=>handleChange(e.target.checked, 'suppress', item.id)}/>
                </Form.Item>
              </Col>
              <Col span={1}>
                {renwalFees.length > 1 ? (
                  <Button
                    className="roundSmallButton"
                    onClick={() => {
                      removeRenewal(item.id);
                    }}
                    type="primary"
                    shape="circle"
                    icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                    size={"small"}
                  />
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </li>
        ))}
        <Button
          className="addPropertyGroupButton"
          type="primary"
          onClick={()=>addRenewal()}
          size={"small"}
          icon={<i className="fa-solid fa-circle-plus"></i>}
          style={{width: "100%"}}
        >
          Add Another Fee
        </Button>
      </ul>
    </>
  );
}

export default AdditionalFees;
